// Reusable share strip used by article and standalone story pages.
// Navy + gold aesthetic, thin gold separator, three platform buttons.

const NAVY = "#1B2F5E";
const NAVY_HOVER = "#14224a";
const GOLD = "#C9A96E";

function openShare(url) {
  window.open(url, "_blank", "noopener,noreferrer,width=640,height=560");
}

// Inline SVG icons — kept small so the section stays lightweight.
const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden {...props}>
    <path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.79l-5.32-6.94L4.83 22H1.57l8.02-9.16L1 2h6.91l4.82 6.36L18.244 2Zm-2.38 18h1.87L7.25 4H5.28l10.58 16Z" />
  </svg>
);

const LinkedInIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden {...props}>
    <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.38-1.85 3.62 0 4.29 2.38 4.29 5.48v6.26ZM5.34 7.43a2.06 2.06 0 1 1 0-4.11 2.06 2.06 0 0 1 0 4.11Zm1.77 13.02H3.56V9h3.55v11.45ZM22.22 0H1.77C.79 0 0 .78 0 1.75v20.5C0 23.22.79 24 1.77 24h20.45c.98 0 1.78-.78 1.78-1.75V1.75C24 .78 23.2 0 22.22 0Z" />
  </svg>
);

const FacebookIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden {...props}>
    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.93v-7.02H7.9v-2.9h2.54V9.85c0-2.52 1.5-3.92 3.78-3.92 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.77l-.44 2.9h-2.33V22c4.78-.78 8.43-4.92 8.43-9.94Z" />
  </svg>
);

export default function ShareSection({ title, url, testid = "share-section" }) {
  const encodedUrl = encodeURIComponent(url);
  const twitterText = encodeURIComponent(`Just read: ${title} — ${url} via @SummaryMaps 🗺️`);
  const twitterHref = `https://twitter.com/intent/tweet?text=${twitterText}`;
  const linkedinHref = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
  const facebookHref = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;

  const btnBase = "inline-flex items-center gap-2 px-5 sm:px-6 py-2.5 sm:py-3 rounded-full text-sm font-medium transition-all";
  const btnStyle = {
    background: NAVY,
    color: "#fff",
    border: `1px solid ${NAVY}`,
  };

  const buttons = [
    { key: "x", label: "X", href: twitterHref, Icon: XIcon, aria: "Share on X" },
    { key: "linkedin", label: "LinkedIn", href: linkedinHref, Icon: LinkedInIcon, aria: "Share on LinkedIn" },
    { key: "facebook", label: "Facebook", href: facebookHref, Icon: FacebookIcon, aria: "Share on Facebook" },
  ];

  return (
    <section
      className="mt-12 sm:mt-16 pt-10 sm:pt-12"
      style={{ borderTop: `1px solid ${GOLD}66` }}
      data-testid={testid}
    >
      <h3
        className="font-serif text-center text-xl sm:text-2xl font-semibold"
        style={{ color: NAVY }}
      >
        Share this Summary
      </h3>
      <div className="mt-6 sm:mt-8 flex flex-wrap items-center justify-center gap-3 sm:gap-4">
        {buttons.map(({ key, label, href, Icon, aria }) => (
          <button
            key={key}
            type="button"
            aria-label={aria}
            onClick={() => openShare(href)}
            className={btnBase}
            style={btnStyle}
            data-testid={`share-${key}`}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = NAVY_HOVER;
              e.currentTarget.style.borderColor = GOLD;
              e.currentTarget.style.color = GOLD;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = NAVY;
              e.currentTarget.style.borderColor = NAVY;
              e.currentTarget.style.color = "#fff";
            }}
          >
            <Icon />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
